import { Media, MovieRewardsInfo } from '@cinemark/content-api-client';

type BenefitType = 'movie-fan' | 'movie-club';

type BenefitData = {
  header?: string;
  image?: Media;
  imageSmall?: Media;
  text?: string;
};

export const getBenefits = (movieRewardsInfo: MovieRewardsInfo, type: BenefitType): BenefitData[] => {
  const prefix = type === 'movie-fan' ? 'movieFanBenefit' : 'movieClubBenefit';

  return [
    {
      header: movieRewardsInfo[`${prefix}Header1`],
      image: movieRewardsInfo[`${prefix}Image1`],
      imageSmall: movieRewardsInfo[`${prefix}ImageSm1`],
      text: movieRewardsInfo[`${prefix}Text1`],
    },
    {
      header: movieRewardsInfo[`${prefix}Header2`],
      image: movieRewardsInfo[`${prefix}Image2`],
      imageSmall: movieRewardsInfo[`${prefix}ImageSm2`],
      text: movieRewardsInfo[`${prefix}Text2`],
    },
    {
      header: movieRewardsInfo[`${prefix}Header3`],
      image: movieRewardsInfo[`${prefix}Image3`],
      imageSmall: movieRewardsInfo[`${prefix}ImageSm3`],
      text: movieRewardsInfo[`${prefix}Text3`],
    },
  ].filter(benefit => benefit.image?.url || benefit.imageSmall?.url || benefit.header || benefit.text);
};

export const shouldShowSection = (
  header: string | undefined,
  benefitsCount: number,
  hasCTA: boolean
): boolean => {
  return !!(header || benefitsCount > 0 || hasCTA);
};
